<template>
  <BaseModal
    :title="subLearningOutcome ? 'Edit a sub-learning outcome' : 'Create a sub-learning outcome'"
    size="xl"
    :show.sync="$show"
  >
    <b-form class="form__sub-lo">
      <div class="my-4">
        <label for="text__ultimate-lo"
          >Align to ultimate learning outcome <span class="text-black-50">(Read-only)</span></label
        >
        <b-form-input
          v-model="ultimateLearningOutcome.title"
          name="text__ultimate-lo"
          class="text__ultimate-lo"
          type="text"
          disabled
        ></b-form-input>
      </div>

      <div class="mb-4">
        <label for="input__title">Title</label>
        <b-form-input
          v-model="$v.title.$model"
          name="input__title"
          class="input__title"
          :disabled="disabled"
          :class="{
            'is-invalid': $v.title.$error,
            'is-valid': !$v.title.$invalid
          }"
        ></b-form-input>
        <b-form-invalid-feedback v-if="!$v.title.required">
          Title is required.
        </b-form-invalid-feedback>
      </div>

      <div>
        <label for="input__description">
          <span class="mr-1">Description</span>
          <span class="text-muted">(Optional)</span>
        </label>

        <base-text-editor
          v-model="description"
          name="input__description"
          class="input__description"
          :disabled="disabled"
        ></base-text-editor>
      </div>
    </b-form>

    <template #modal-footer>
      <div class="d-flex justify-content-start w-100">
        <b-button
          :disabled="disabled"
          type="submit"
          variant="success"
          class="btn__submit"
          @click.prevent="onSubmit"
        >
          <b-spinner v-if="submitting" />
          <span v-else>{{ subLearningOutcome ? 'Save' : 'Create' }}</span>
        </b-button>
        <!-- 
        <b-button
          id="button-add"
          variant="success"
          type="submit"
          @click.prevent="onSubmit"
        >
          {{ subLearningOutcome ? "Save" : "Create" }}
        </b-button> -->

        <b-button
          id="button-cancel"
          :disabled="disabled"
          variant="link"
          class="btn__cancel btn-link-dark"
          @click="hide"
        >
          Cancel
        </b-button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { LearningOutcome } from '@/models/LearningOutcome';
import BaseModal from '@/components/base-components/BaseModal';
import BaseTextEditor from '@/components/base-components/BaseTextEditor';

export default {
  components: {
    BaseModal,
    BaseTextEditor
  },
  mixins: [validationMixin],

  validations() {
    return {
      title: { required }
    };
  },

  props: {
    ultimateLearningOutcome: {
      type: LearningOutcome,
      required: true
    },

    subLearningOutcome: {
      type: LearningOutcome,
      default: null
    },

    show: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      invalid: false,
      disabled: false,
      submitting: false,
      title: '',
      description: null
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(show) {
        if (show) {
          this.title = this.subLearningOutcome ? this.subLearningOutcome.title : '';
          this.description = this.subLearningOutcome ? this.subLearningOutcome.description : null;
        }
      }
    }
  },

  methods: {
    async onSubmit() {
      this.$v.$touch();

      this.invalid = false;

      if (this.$v.$invalid) {
        this.invalid = true;

        return this.$toast.error(
          `Cannot ${
            this.subLearningOutcome ? 'update' : 'create'
          } sub-learning outcome, please check error messages`
        );
      }

      let promise;

      const { title, description } = this;

      try {
        this.disabled = true;
        this.submitting = true;

        const formData = {
          title,
          description,
          ultimate_learning_outcome: this.ultimateLearningOutcome.id
        };

        if (this.subLearningOutcome) {
          promise = await LearningOutcome.api().updateSubLearningOutcome(
            this.subLearningOutcome.id,
            formData
          );

          this.$emit('update', {
            id: this.subLearningOutcome.id,
            data: formData
          });
        } else {
          promise = await LearningOutcome.api().createSubLearningOutcome(formData);

          const { id } = promise.response.data;

          let {
            id: ultimateLearningOutcomeId,
            sub_learning_outcome_ids = [],
            properties = '{}'
          } = this.ultimateLearningOutcome;

          properties = JSON.parse(properties);

          const { order = [] } = properties;

          LearningOutcome.update({
            where: ultimateLearningOutcomeId,

            data: {
              sub_learning_outcome_ids: [...sub_learning_outcome_ids, id]
            }
          });

          order.push({ id, model: 'learning-outcomes', children: [] });

          await LearningOutcome.api().updateProperties(ultimateLearningOutcomeId, {
            ...properties,
            order
          });

          this.$emit('create', { id, data: formData });
        }

        this.$toast.success(
          `The sub-learning outcome was ${this.id ? 'updated' : 'created'} successfully`
        );

        this.$emit('submit', formData);

        // this.hide();
      } catch (error) {
        console.log(error);

        this.$toast.error(
          `Cannot ${this.subLearningOutcome ? 'update' : 'create'} an sub-learning outcome`
        );
      } finally {
        this.submitting = false;
        this.disabled = false;
      }

      return promise;
    },
    // show() {
    //   this.$bvModal.show(`modal-create-or-update-sub-lo`);
    // },
    hide() {
      this.$show = false;

      this.clearDate();
    },
    clearDate() {
      this.$v.$reset();

      this.title = '';
      this.description = '';
    }
  }
};
</script>
